import Events from '../constants/events';

const PendoEvents = {
  ApplicationSubmit: 'ApplicationSubmit',
  ApplicationSubmit_VA: 'ApplicationSubmit-VA-202508-GroupCode',
};

const VA_GROUP_CODE = '0853877BDAEDF443';

class PendoListener {
  constructor(emitter) {
    // Bind to the applicationSubmit event
    emitter.on(Events.ApplicationSubmit, (data) => PendoListener.#onApplicationSubmit(data));
  }

  static #onApplicationSubmit(data) {
    // Publish successful application submission events to Pendo
    if (!data.hasError) {
      const event = data.teamCode === VA_GROUP_CODE ? PendoEvents.ApplicationSubmit_VA : PendoEvents.ApplicationSubmit;
      PendoListener.#publishEvent(event, {
        affiliationStatus: data.affiliationStatus,
        applicationStatus: data.applicationStatus,
        applicationType: data.applicationType,
        referredOrgId: data.referredOrgId,
        teamCode: data.teamCode,
        teamId: data.teamId,
        teamType: data.teamType,
      });
    }
  }

  static #publishEvent(name, data) {
    if (window.pendo && typeof window.pendo?.track === 'function') {
      window.pendo.track(name, data);
    }
  }
}

/**
 * Event listener that shuttles events to Pendo
 * @param emitter Event emitter
 */
export default PendoListener;
